export default function LegalPage({ title, effectiveDate, children }) {
  return (
    <section className="max-w-[900px] mx-auto px-4 sm:px-6 py-12">
      <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#4361EE]">Legal</p>
      <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter mt-2">{title}</h1>
      {effectiveDate && <p className="text-sm font-semibold text-[#4A4A4A] mt-3">Effective date: {effectiveDate}</p>}
      <div className="nb-card p-6 sm:p-8 mt-8 space-y-6 legal-prose">{children}</div>
    </section>
  );
}
